const make_modify_css_property_function = (property) => {
    return (selector, value) => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            element.style[property] = value;
        })
    }
}

const modify_zIndex = make_modify_css_property_function('zIndex')
const modify_opacity = make_modify_css_property_function('opacity')
const modify_display = make_modify_css_property_function('display')
const modify_transform = make_modify_css_property_function('transform')

export function qplus_before_capture() {
    modify_opacity('.map-ctrl.map-top-right-ctrl', 0)
    modify_display('.pane-tag', 'block')
    modify_zIndex('.map-ctrl.map-right-bottom-ctrl', 3000)
    modify_zIndex('.capture_img-container', 2)
    modify_opacity('.map-timebar', 0)
    modify_opacity('.map-tool', 0)
    modify_display('.colorbar-help-btn', 'none')
    modify_opacity('.typhoon--forecast', 0)
    modify_opacity('.typhoon-forecast-tooltip', 0)
    modify_transform('.colorbar', 'translateY(5rem)')
    modify_display('.cursor-latlng__text', 'none')
    modify_transform('#accumulated_precp', 'translateY(5rem)')
    modify_display('.colorbar-cursor-item', 'none')
}

export function qplus_after_capture() {
    modify_opacity('.map-ctrl.map-top-right-ctrl', 1)
    modify_display('.pane-tag', 'none')
    modify_zIndex('.map-ctrl.map-right-bottom-ctrl', 0)
    modify_zIndex('.capture_img-container', -1)
    modify_opacity('.map-timebar', 1)
    modify_opacity('.map-tool', 1)
    modify_display('.colorbar-help-btn', 'block')
    modify_opacity('.typhoon--forecast', 1)
    modify_opacity('.typhoon-forecast-tooltip', 1)
    modify_transform('.colorbar', 'translateY(0)')
    modify_display('.cursor-latlng__text', 'block')
    modify_transform('#accumulated_precp', 'translateY(0)')
    modify_display('.colorbar-cursor-item', 'block')
}